export class AdminDashboard {
  businessLive: BusinessLiveData[];
  turnoverConsolidated: TurnoverConsolidatedData[];
  collaboratorCostsLive: collaboratorCostsLiveData[];
  surveyorCostsLive: SurveyorCostsLiveData[];
  cashStatusConsolidated: CashStatusConsolidatedData[];
  constructor(data: Partial<AdminDashboard> = {}) {
    Object.assign(this, data);
  }

  get serialised() {
    return {};
  }
}

export interface MonthlyData {
  year: number;
  monthNumber: number;
}

interface BusinessLiveData extends MonthlyData {
  employeeCasaDocCost: number;
  prepaidCasaDocCost: number;
  businessProfit: number;
}

interface TurnoverConsolidatedData extends MonthlyData {
  employeeCasaDocCost: number;
  prepaidCasaDocCost: number;
  businessProfit: number;
}

interface collaboratorCostsLiveData extends MonthlyData {
  accountsCost: number;
  extraAccountCost: number;
  accountantsCost: number;
  istruttoreCost: number;
  protocolloCost: number;
  ricercaAttoCost: number;
  provenienzaCost: number;
}

interface SurveyorCostsLiveData extends MonthlyData {
  technicalReportGrossPrice: number;
  apeGrossPrice: number;
  extraGrossPrice: number;
}

interface CashStatusConsolidatedData extends MonthlyData {
  employeeCasaDocCost: number;
  prepaidCasaDocCost: number;
  surveyorsTransferAmount: number;
  bookletGrossPriceAndRevenueStampTotal: number;
  revenueStampTotal: number;
}
